// API client tipado pra `GET /api/users` (Story 11.4 — picker de responsável).
// READ-ONLY. Lista usuários ativos (id/name/role) pra popular selects de
// responsável (LeadForm, DealForm). Padrão: wrapper sobre apiClient + Zod parse.

import { z } from 'zod';

import { userPickerSchema, type UserPicker } from '@control-center/shared';

import { apiClient } from './api-client';

const listResponseSchema = z.object({
  items: z.array(userPickerSchema),
});

export type { UserPicker };

/** GET /api/users — lista usuários ativos pro picker de responsável. */
export async function fetchUsers(signal?: AbortSignal): Promise<UserPicker[]> {
  const { data } = await apiClient.get('/api/users', { signal });
  return listResponseSchema.parse(data).items;
}
